module.exports = __webpack_public_path__ + "static/media/textProduct_Integrations.691b2838.md";